import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ScreenContainerControl } from "doshx_controls_web";
import { AccountMenu } from "../../../components/account-menu/account-menu";
import { OrderList } from "./order-list/order-list";
import { OrderDetailsPage } from "./order-details/order-details";
import { Breadcrumb } from "../../../components/breadcrumb";
export const OrdersPage = () => {
    return (React.createElement("div", null,
        React.createElement(Breadcrumb, { items: [{ label: "Home" }, { label: "Account" }, { label: "My Orders", active: true }], title: "My Orders" }),
        React.createElement(ScreenContainerControl, { className: "flex flex-col lg:flex-row items-start justify-start gap-8 px-8 py-8 md:max-w-full" },
            React.createElement("div", { className: "w-full lg:w-1/4 xl:w-1/5" },
                React.createElement(AccountMenu, null)),
            React.createElement("div", { className: "w-full lg:w-3/4 xl:w-4/5" },
                React.createElement(Routes, null,
                    React.createElement(Route, { index: true, element: React.createElement(Navigate, { to: `/orders/list` }) }),
                    React.createElement(Route, { path: `/list`, element: React.createElement(OrderList, null) }),
                    React.createElement(Route, { path: `/order`, element: React.createElement(OrderDetailsPage, null) }))))));
};
